import { render, staticRenderFns } from "./ChangeTypeSignerModal.vue?vue&type=template&id=49be1b33&lang=pug"
import script from "./ChangeTypeSignerModal.vue?vue&type=script&lang=js"
export * from "./ChangeTypeSignerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports